import { useSearchParams } from "react-router-dom";
import FormConstatNew from "../../components/forms/FormConstatNew/FormConstatNew";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import {
  useFetchAuditQuery,
  useFetchAuditsQuery,
  useFetchConstatGravitiesQuery,
  useFetchSitesQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";

const PageConstatCreate = () => {
  const [searchParams] = useSearchParams();
  const auditId = searchParams.get("auditId");

  const { data: fixedAudit, isFetching: isFetchingAudit } = useFetchAuditQuery(
    Number(auditId),
    { skip: !auditId },
  );
  const { data: sitesData } = useFetchSitesQuery();
  const { data: auditsData } = useFetchAuditsQuery(undefined, {
    skip: !!auditId,
  });
  const { data: pilotes } = useFetchUsersForFieldQuery("pilote");
  const { data: admins } = useFetchUsersForFieldQuery("sdlp-superadmin");
  const { data: constatGravitiesData } = useFetchConstatGravitiesQuery();

  const isReady = !auditId || !!fixedAudit;

  return (
    <PageLayout isLoading={!!auditId && isFetchingAudit}>
      <h1>Nouveau constat</h1>
      {isReady && (
        <FormConstatNew
          sites={sitesData?.results}
          audits={auditsData?.results}
          fixedAudit={fixedAudit}
          pilotes={pilotes}
          admins={admins}
          constatGravities={constatGravitiesData?.results}
        />
      )}
    </PageLayout>
  );
};

export default PageConstatCreate;
